// Import the RTK Query methods from the React-specific entry point
import { Paths } from './paths/paths';
import { apiSlice } from './apiSlice';
import { CompanyAuthorizedSignatory } from './response/CompanyAuthorizedSignatory';
import { CompanyAuthorizedSignatory as CompanyAuthorizedSignatoryRequest } from './request/CompanyAuthorizedSignatory';

export const companySlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    companyAuthorizedSignatories: builder.query<
      CompanyAuthorizedSignatory[],
      void
    >({
      query: () => Paths.CompanySignatory,
      providesTags: ['company_signatories'],
    }),
    createAuthorizedSignatory: builder.mutation<
      CompanyAuthorizedSignatory,
      Omit<CompanyAuthorizedSignatoryRequest, 'id'>
    >({
      query: (data) => ({
        url: Paths.CompanySignatory,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error) =>
        error ? [] : ['company_signatories'],
    }),
    updateAuthorizedSignatory: builder.mutation<
      CompanyAuthorizedSignatory,
      Omit<Partial<CompanyAuthorizedSignatoryRequest>, 'id' | 'isPrimary'> & {
        id: string;
      }
    >({
      query: (data) => ({
        url: Paths.CompanySignatory,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error) =>
        error ? [] : ['company_signatories'],
    }),
    deleteAuthorizedSignatory: builder.mutation<void, { signatoryId: string }>({
      query: (data) => ({
        url: Paths.CompanySignatory,
        method: 'DELETE',
        params: data,
      }),
      invalidatesTags: (result, error) =>
        error ? [] : ['company_signatories'],
    }),
  }),
});

export const {
  useCompanyAuthorizedSignatoriesQuery,
  useCreateAuthorizedSignatoryMutation,
  useUpdateAuthorizedSignatoryMutation,
  useDeleteAuthorizedSignatoryMutation,
} = companySlice;
